import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';

export const footerLinks = [
  {
    id: 1,
    title: 'About Us',
    links: [
      'How it works',
      'Testimonials',
      'Careers',
      'Investors',
      'Terms of Service'
    ]
  },
  {
    id: 2,
    title: 'Services',
    links: [
      'Free Account',
      'Pay on Click',
      'Money Transfer',
      'E-banking app',
      'Investors'
    ]
  },
  {
    id: 3,
    title: 'Contact Us',
    links: [
      'Contact',
      'Support Us',
      'Destinations',
      'Sponsorship',
      'Terms of Service'
    ]
  },
  {
    id: 4,
    title: 'Social Media',
    links: ['Instagram', 'Facebook', 'YouTube', 'Twitter']
  }
];

export const socialIcon = [
  {
    id: 1,
    icon: <FaFacebook />
  },
  {
    id: 2,
    icon: <FaInstagram />
  },
  {
    id: 3,
    icon: <FaTwitter />
  }
];
